let appBarMode = 'default'

export function setAppBarMode(mode) {
    appBarMode = mode
}

export function isShowAppBar() {
    if (appBarMode === 'enabled') {
        return true
    } else if (appBarMode === 'disabled') {
        return false
    } else {
        return !isInWechatEnv();
    }
}

export function isInAppWebview() {
    if (window.mofangBridge) { // Android
        return true;
    } else if (window.navigator.userAgent.indexOf('Mofang-iOS/') >= 0) { // iOS
        return true;
    } else {
        return false;
    }
}

export function isInWechatEnv() {
    return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') >= 0;
}
